import React, { useCallback, useMemo } from 'react';
import { getColumns } from './columns';
import { Link } from 'react-router-dom';
import { Button, Popup } from 'semantic-ui-react';
import VirtualTable from 'components/VirtualTable/VirtualTable';
import './retry-shipments-table.scss';
import { originsPaths } from 'pages/RetryShipmentPage/RetryShipmentPage';

export default function RetryShipmentsTable({
  loading,
  origin,
  shipments,
  lastResetSelectedRows,
  hasNextPage,
  onRowSelect = () => {},
  onLoadMoreItems = () => {},
}) {
  const renderActions = useCallback(
    (row) => {
      const path = originsPaths[origin] || '/retry-shipments';

      return (
        <Popup
          className="base-tooltip"
          content="Solucionar problemas"
          trigger={
            <Link
              to={{
                pathname: `${path}/${row.reference}`,
              }}
            >
              <Button circular icon="pencil alternate" />
            </Link>
          }
        />
      );
    },
    [origin],
  );

  const columns = useMemo(() => getColumns(renderActions), [renderActions]);

  return (
    <VirtualTable
      loading={loading}
      tableClassNames="retry-shipments-table"
      columns={columns}
      data={shipments}
      selectable
      hasNextPage={hasNextPage}
      lastResetSelectedRows={lastResetSelectedRows}
      onLoadMoreItems={onLoadMoreItems}
      onRowSelect={onRowSelect}
    />
  );
}
